export default ({ store }) => {
  if (store.getters['pricePlans/all'].length > 0) {
    return;
  }

  store.dispatch('pricePlans/fetch');
};
